module.exports = __webpack_public_path__ + "static/media/ncl-logo-hrz.207da980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/ncl-logo-hrz.png
// module id = 130
// module chunks = 21